<template>
	<div v-if="uuid" :id="'vimeo-player-' + this.uuid + this.id"></div>
</template>

<script>
	import VimeoVideoMixin from "../mixins/v2/VimeoVideoMixin";

	export default {
		name: 'VimeoVideo',

		mixins: [ VimeoVideoMixin ],

		props: {
			id: {
				required: true,
			},
		},

		data() {
			return {
				vimeo_player: false,
				uuid: false,
			};
		},

		created() {
			this.uuid = Math.floor(Math.random() * 999999);
		},

		mounted() {
			this.vimeo_player = this.initializeVimeoVideo(this.uuid, this.id);
		},
	};
</script>